import { useEffect, useState } from "react";
import { storage } from "./storage";

export type ThemePreference = "light" | "dark" | "system";
const KEY = "erp.theme";
const media = window.matchMedia("(prefers-color-scheme: dark)");

function resolve(pref: ThemePreference): "light" | "dark" {
  return pref === "system" ? (media.matches ? "dark" : "light") : pref;
}

function apply(pref: ThemePreference) {
  const theme = resolve(pref);
  document.documentElement.dataset.theme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", theme === "dark" ? "#070F19" : "#0A1828");
}

function read(): ThemePreference {
  const value = storage.get(KEY);
  return value === "light" || value === "dark" ? value : "system";
}

apply(read());

export function useTheme(): [ThemePreference, (pref: ThemePreference) => void] {
  const [pref, setPref] = useState<ThemePreference>(read);
  useEffect(() => {
    apply(pref);
    if (pref !== "system") return;
    const onChange = () => apply("system");
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, [pref]);
  return [
    pref,
    (next) => {
      storage.set(KEY, next);
      setPref(next);
    },
  ];
}
